__turbopack_context__.v({
  "container": "AddressForm-module__aVOsCa__container",
  "fieldGroup": "AddressForm-module__aVOsCa__fieldGroup",
  "half": "AddressForm-module__aVOsCa__half",
  "label": "AddressForm-module__aVOsCa__label",
  "row": "AddressForm-module__aVOsCa__row",
});
